import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "de",
  "use": "de-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"de\">\n  <path fill=\"#ffce00\" d=\"M0 341.3h512V512H0z\" />\n  <path d=\"M0 0h512v170.7H0z\" />\n  <path fill=\"#d00\" d=\"M0 170.7h512v170.6H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/de.svg
// module id = null
// module chunks = 